import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Inquiries Types */
import {
  Settings,
  _Inquiry
} from '../namespace-helper'

import _ from 'lodash'

const selectedInquiryTemplate = {
  id: 0,
  customers_id: 0,
  customers_branch_offices_id: 0,
  customers_branch_offices_contacts_id: 0,
  rfq_number: '',
  deadline: '',
  project_number: '',
  accounts_id: 0,
  inquiries_status_id: 0
}

export default {
  namespaced: true,
  state: {
    inquiries: [],
    selectedInquiry: _.cloneDeep(selectedInquiryTemplate),
    openDialog: false
  },
  mutations: {
    [_Inquiry.mutations.setInquiries] (state, payload) {
      state.inquiries = payload
    },
    [_Inquiry.mutations.setSelectedInquiry] (state, payload) {
      if (payload !== null) {
        state.selectedInquiry = payload
      } else {
        state.selectedInquiry = _.cloneDeep(selectedInquiryTemplate)
      }
    },
    [_Inquiry.mutations.setOpenCloseInquiryDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_Inquiry.actions.saveInquiries] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/inquiries'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_Inquiry.mutations.setSelectedInquiry, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/inquiries/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            context.commit(_Inquiry.mutations.setSelectedInquiry, r.data.data)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_Inquiry.actions.loadInquiries] (context, payload) {
      console.log('loadInquiries: ' + JSON.stringify(payload))
      console.log('loadInquiries: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/inquiries?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'rfq_number:like;' +
                'project_number:like;' +
                'customer.name:like;' +
                'account.firstname:like;' +
                'inquiriesStatus.name:like;' +
                'inquiresPositions.internal_number:like;' +
                'inquiresPositions.item_number:like;' +
                'inquiresPositions.product.reference:like' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending +
                        '&statusFilter=' + payload.statusFilter

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Inquiry.mutations.setInquiries, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Inquiry.actions.loadInquiryStatus] (context, payload) {
      console.log('loadInquiryStatus: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/inquiryStatuses'

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Inquiry.actions.loadInquiry] (context, payload) {
      console.log('loadInquiry: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/inquiries/' + payload.id
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_Inquiry.actions.openCloseInquiryDialog] ({ commit }) {
      commit(_Inquiry.mutations.setOpenCloseInquiryDialogState)
    },
    [_Inquiry.actions.setSelectedInquiry] ({ commit }, payload) {
      commit(_Inquiry.mutations.setSelectedInquiry, payload)
    },
    [_Inquiry.actions.resetState] ({ commit }, payload) {
      commit(_Inquiry.mutations.setInquiries, [])
      commit(_Inquiry.mutations.setSelectedInquiry, null)
    }
  },
  getters: {
    [_Inquiry.getters.inquiries] (state) {
      return state.inquiries
    },
    [_Inquiry.getters.getOpenInquiryDialogState] (state) {
      return state.openDialog
    },
    [_Inquiry.getters.getSelectedInquiry] (state) {
      return state.selectedInquiry
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Inquiry/inquiries.js